<!-- HM idle modal dialog -->
<template>
  <b-modal :id="id" class="modal-primary" hide-header-close v-model="dlgIdle">
    <div class="font-weight-bold" slot="modal-title">
      <i class="fa fa-hourglass pr-2"></i>Session Timeout Warning
    </div>
    <p>
      Your session will expire automatically in
      <strong>{{countdown}}</strong> seconds.
    </p>
    <p>Select &quot;Continue&quot; to extend your session.</p>
    <div slot="modal-footer">
      <b-button variant="default" @click="onIdleLogout">Logout</b-button>
      <b-button variant="primary" class="ml-2" @click="onIdleCancel">Continue</b-button>
    </div>
  </b-modal>
</template>

<script>
const defaultCountdown = 60; // seconds

export default {
  name: 'HMIdle',
  props: {
    id: {
      type: String,
      default: function () {
        return 'idle-dlg-' + this._uid;
      }
    },
    timeout: {
      type: Number,
      default: defaultCountdown
    }
  },
  data() {
    return {
      dlgIdle: false,
      countdown: this.timeout,
      interval: false
    }
  },
  methods: {
    onIdleCancel() {
      this.dlgIdle = false;
      clearInterval(this.interval);
      this.interval = null;
    },
    onIdleLogout() {
      this.onIdleCancel();
      return this.$router.push('/login');
    }
  },
  onIdle() {
    console.log('onIdle');
    this.dlgIdle = true;
    this.countdown = this.timeout;

    // countdown seconds, when reaches 0 then call idle logout
    let self = this;
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => { if (self.countdown <= 1) { self.onIdleLogout() } else { self.countdown--; } }, 1000);
  }
}
</script>